import { render, staticRenderFns } from "./regl_facture_assurance.vue?vue&type=template&id=3acb650c&scoped=true&"
import script from "./regl_facture_assurance.vue?vue&type=script&lang=js&"
export * from "./regl_facture_assurance.vue?vue&type=script&lang=js&"
import style0 from "./regl_facture_assurance.vue?vue&type=style&index=0&id=3acb650c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acb650c",
  null
  
)

export default component.exports